import { generateWords } from "../utils/generate";

export function createPrinter() {
  return {
    id: Math.round(Math.random() * 10000),
    name: generateWords(1, "spaced"),
  };
}
